import React, { useEffect, useState } from 'react';
import SynchrotronTripsRow from './CustomComponents/SynchrotronTripsRow';
import SynchTripService from 'business/services/SynchrotronTripService';
import { SynchTripDTO } from 'business/models/Models';

export default function SynchrotronTrips() {
  const [list, setList] = useState([]);

  useEffect(() => {
    async function fetchSynchrotronTrips() {
      const synchTripService = new SynchTripService();
      const synchTrips: SynchTripDTO[] =
        await synchTripService.getLatestSynchrotronTrips();
      setList(synchTrips);
    }

    fetchSynchrotronTrips();
  }, []);

  function getRows() {
    const render = [];
    list?.map((l, index) => {
      render.push(
        <SynchrotronTripsRow
          key={`synchrotron-trips-row-${index}`}
          id={l.id}
          title={l.synchTripName}
          collectionDate={l.dataCollectionDate}
        />,
      );
    });
    return render;
  }

  return (
    <div id='synchrotrontrips-container' className="synchrotron sectionBorder" title={'Synchrotron Trips'}>
      <div id='synchrotrontrips-grid-header' className="gridColumnHeader">Synchrotron Trips</div>
      <div id='synchrotrontrips-body' className="synchrotronBody">{getRows()}</div>
    </div>
  );
}
